import CreatFastJobOffer from '../../../JobOffers/components/CreatFastJobOffer'
import useResize from '../../../../hooks/useResize'
import { VIEWPORT_LG } from '../../../../utils/constants'

const FastHutritNextCompany = () => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  return (
    <div
      className="lumpy-background"
      style={{
        height: '100vh',
        paddingLeft: isMobile ? '' : '92px',
      }}
    >
      <div className="d-flex flex-lg-row flex-column align-items-center justify-content-center w-100 mt-lg-5 pt-lg-5">
        <div className="d-flex flex-column w-100">
          <span
            className="text-on-bg-primary"
            style={{
              textAlign: isMobile ? 'center' : '',
              fontSize: isMobile ? '32px' : '64px',
              fontWeight: '1000',
              lineHeight: isMobile ? '' : '75px',
            }}
          >
            ¿Buscas un <br className="d-lg-flex d-none" /> perfil{' '}
            <br className="d-flex d-lg-none" /> en{' '}
            <br className="d-lg-flex d-none" /> tecnología?
          </span>
          <span
            style={{
              textAlign: isMobile ? 'center' : '',
              fontSize: isMobile ? '20px' : '32px',
            }}
          >
            Solo cuéntanos qué perfil quieres y te <br /> enviamos candidatos
            listos para <br /> entrevistar.
          </span>
        </div>
        <div className="w-100">
          <CreatFastJobOffer />
        </div>
      </div>
    </div>
  )
}

export default FastHutritNextCompany
